<div class="d-flex flex-wrap">
  <div class="{{itemClass}}" *ngFor="let item of options;let i=index">
    <div class="border m-1 order-1 pointer px-2 question-toggle-item"
      [class.active]="isSelected(item)" (click)="toggle(item)">
      <i class="far fa-{{isSelected(item) ? 'check-' : ''}}{{multiple ? 'square' : 'circle'}} fs-xl ml-1 "></i>
      {{(labels?.length == options.length) ? labels[i] : item}}
    </div>
  </div>
  <div class="d-flex p-1 w-100" *ngIf="canAdd">
    <input class="input lh-1 py-1" [placeholder]="placeholder" type="text" #other
      (change)="toggle(other.value, true);other.value= '';other.focus()" />
    <div class="border mr-1 pointer px-2 rounded yellow-bg" (click)="other.blur()" [class.f-green]="!!other.value"><i
        class="fa fa-plus"></i></div>
  </div>
</div>